import type { MappingKind } from '../../api/types';

/** The kinds as people see them: a mapping's kind and the code list it is checked against share them. */
export const kindLabelKeys = {
  Unit: 'mappings.kinds.Unit',
  PaymentMeans: 'mappings.kinds.PaymentMeans',
  DocumentType: 'mappings.kinds.DocumentType',
  TaxCategory: 'mappings.kinds.TaxCategory',
  TaxExemptionReason: 'mappings.kinds.TaxExemptionReason',
  AllowanceReason: 'mappings.kinds.AllowanceReason',
  ChargeReason: 'mappings.kinds.ChargeReason',
  Country: 'mappings.kinds.Country',
  Currency: 'mappings.kinds.Currency',
  TaxPointDateCode: 'mappings.kinds.TaxPointDateCode',
  PartyIdScheme: 'mappings.kinds.PartyIdScheme',
  StandardItemScheme: 'mappings.kinds.StandardItemScheme',
  ItemClassScheme: 'mappings.kinds.ItemClassScheme',
  AttachmentMimeType: 'mappings.kinds.AttachmentMimeType',
} as const satisfies Record<MappingKind, string>;

export const kindDescriptionKeys = {
  Unit: 'mappings.kindDescriptions.Unit',
  PaymentMeans: 'mappings.kindDescriptions.PaymentMeans',
  DocumentType: 'mappings.kindDescriptions.DocumentType',
  TaxCategory: 'mappings.kindDescriptions.TaxCategory',
  TaxExemptionReason: 'mappings.kindDescriptions.TaxExemptionReason',
  AllowanceReason: 'mappings.kindDescriptions.AllowanceReason',
  ChargeReason: 'mappings.kindDescriptions.ChargeReason',
  Country: 'mappings.kindDescriptions.Country',
  Currency: 'mappings.kindDescriptions.Currency',
  TaxPointDateCode: 'mappings.kindDescriptions.TaxPointDateCode',
  PartyIdScheme: 'mappings.kindDescriptions.PartyIdScheme',
  StandardItemScheme: 'mappings.kindDescriptions.StandardItemScheme',
  ItemClassScheme: 'mappings.kindDescriptions.ItemClassScheme',
  AttachmentMimeType: 'mappings.kindDescriptions.AttachmentMimeType',
} as const satisfies Record<MappingKind, string>;

/** The root of each kind's guide texts (`what`, `source`, `target`, `default`, `examples`). */
export const kindGuideKeys = {
  Unit: 'mappings.kindGuide.Unit',
  PaymentMeans: 'mappings.kindGuide.PaymentMeans',
  DocumentType: 'mappings.kindGuide.DocumentType',
  TaxCategory: 'mappings.kindGuide.TaxCategory',
  TaxExemptionReason: 'mappings.kindGuide.TaxExemptionReason',
  AllowanceReason: 'mappings.kindGuide.AllowanceReason',
  ChargeReason: 'mappings.kindGuide.ChargeReason',
  Country: 'mappings.kindGuide.Country',
  Currency: 'mappings.kindGuide.Currency',
  TaxPointDateCode: 'mappings.kindGuide.TaxPointDateCode',
  PartyIdScheme: 'mappings.kindGuide.PartyIdScheme',
  StandardItemScheme: 'mappings.kindGuide.StandardItemScheme',
  ItemClassScheme: 'mappings.kindGuide.ItemClassScheme',
  AttachmentMimeType: 'mappings.kindGuide.AttachmentMimeType',
} as const satisfies Record<MappingKind, string>;
